<template>
    <b-container fluid style="padding-bottom:135px; padding-top:0" class="bg_atos">
        <b-container style="padding-top:80px; margin-bottom:80px">
            <b-row>
                <b-col class="paternTitle">
                    Política de Privacidade 
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <p class="patternText" style="text-indent:0">
                        Instituto Igarapé<br><br>
                        Política de Privacidade - Plataforma <strong>ATOS</strong>
                    </p>
                </b-col>
            </b-row>
            
            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText" style="text-indent:0">Outubro de 2020</p>
                    <p class="patternText">
                    O Instituto Igarapé (CNPJ 14.051.935/0001-01) é o responsável pela Plataforma Atos, doravante indicada como ‘Serviço’.
                    <br><br>
                    Informamos a você nossas políticas de coleta, uso e divulgação de dados pessoais com relação ao uso de nosso serviço, bem como as opções que você possui associadas a estes dados.
                    <br><br>
                    Usamos seus dados para fornecer e melhorar o Serviço. A menos que definido de outra forma nesta Política de Privacidade, os termos nela utilizados têm os mesmos significados que em nossos Termos e de Uso.
                    <br><br>
                    A qualquer momento, você poderá revogar o cadastro em nossa plataforma. Com tal revogação, seus dados serão imediatamente apagados de nossa base.
                    </p>
                </b-col>
            </b-row>

            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                    Coleta e uso de informações pelo serviço
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                        A plataforma ATOS armazena o Nome e o E-mail do usuário para ser usado na autenticação na plataforma e possa receber os alertas por e-mail quando configurado pelo usuário.
                        <br><br>
                        Esses dados são armazenados no Google Firebase, responsável pela autenticação do usuário. Os termos do Firebase incluem Termos de segurança e processamento de dados para todos os serviços do Firebase, com vigência a partir de 25 de maio de 2018. 
                        <br><br>
                        O Firebase é certificado de acordo com os principais padrões de privacidade e segurança.
                        <br><br><br>

                        <strong><h5>Tecnologias de rastreamento & Cookies </h5></strong>
                        
                        Nós usamos a tecnologia Google Analytics para rastrear a atividade em nosso Serviço e manter certas informações através de cookies e tecnologias de rastreamento.
                        <br><br>
                        Google Analytics usam cookies HTTP para armazenar as interações ou ações anteriores do usuário nas páginas do site.
                        <br><br>
                        Você pode instruir seu navegador a recusar todos os cookies ou indicar quando um cookie está sendo enviado. No entanto, se você não aceitar cookies, pode não conseguir usar algumas partes do nosso Serviço. Você pode aprender mais como gerenciar cookies no Guia de cookies do navegador
                        <br><br>
                        Exemplos de cookies que usamos:<br><br>
                        <ul>
                            <li><strong>Cookies de sessão: </strong> são usados para operar nosso Serviço;</li>
                            <li><strong>Cookies de preferência: </strong> são usados para relembrar suas preferências e configurações;</li>
                            <li><strong>Cookies de segurança: </strong> são usados para fins de segurança.</li>
                        </ul>
                    </p>
                </b-col>
            </b-row>

            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                    Uso de Dados
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                        O Instituto Igarapé usa os dados coletados para os seguintes fins:<br><br>
                        <ul>
                            <li>Para fornecer e manter o serviço;</li>
                            <li>Para notificá-lo(la) sobre alterações em nosso serviço;</li>
                            <li>Para permitir que você participe de recursos interativos de nosso serviço quando decidir fazê-lo;</li>
                            <li>Para fornecer suporte ao usuário/a;</li>
                            <li>Para fornecer análises ou informações que possam melhorar o serviço;</li>
                            <li>Para monitorar o uso do serviço;</li>
                            <li>Para detectar, prevenir e resolver problemas técnicos.</li>
                        </ul>
                    </p>
                </b-col>
            </b-row>

            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                Armazenamento e Transferência dos Dados 
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                        Os dados e informações para acesso e utilização de nosso serviço são armazenados no Brasil e são, portanto, 
                        regidos pela legislação brasileira de proteção de dados (Lei 13.709/2018).
                        <br><br>
                        Por esse motivo, suas informações podem ser transferidas e armazenadas em computadores localizados fora de seu estado, 
                        província, país ou outra jurisdição governamental onde as leis de proteção de dados podem ser diferentes daquelas de sua jurisdição.
                        <br><br>
                        Caso você esteja localizado fora do Brasil e escolha nos prover dados e informações, destacamos que realizaremos a transferência e 
                        o processamento desses dados e informações no Brasil. O seu consentimento com esta Política de Privacidade, 
                        seguido do envio de tais elementos, representa a sua concordância com essa transferência.
                        <br><br>
                        O Instituto Igarapé tomará todas as medidas necessárias para garantir que seus dados sejam tratados com segurança, 
                        de acordo com esta Política de Privacidade, e para que nenhuma transferência de seus dados ocorra para uma terceira 
                        organização ou país, a menos que haja controles adequados em vigor, incluindo a segurança de seus dados e informações. 
                    </p>
                </b-col>
            </b-row>
            
            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                   Divulgação de dados
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                        <strong>Requerimentos legais</strong><br><br>
                        O Instituto Igarapé pode divulgar seus dados pessoais caso tal ação seja necessária para:<br></br>
                        <ul>
                            <li>Cumprimento de obrigação legal;</li>
                            <li>Proteção e defesa dos direitos de propriedade do Instituto Igarapé;</li>
                            <li>Prevenção ou investigação de possíveis atos ilícitos em conexão com o Serviço; </li>
                            <li>Proteção da segurança pessoal dos usuários do Serviço ou do público;</li>
                            <li>Proteção contra a responsabilidade legal.</li>
                        </ul>
                    </p>
                </b-col>
            </b-row>

            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                    Segurança de dados
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                        A segurança dos seus dados é importante para nós. Todavia, nenhum método de transmissão pela Internet ou forma de armazenamento 
                        eletrônico é 100% seguro. Embora nos esforcemos para usar os meios que contribuam para a proteção de seus dados pessoais, não podemos 
                        garantir sua segurança absoluta.
                    </p>
                </b-col>
            </b-row>

            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                    Provedores de serviço
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                        Podemos empregar empresas ou indivíduos terceirizados para facilitar nosso Serviço ("Provedores de Serviço"), provê-lo em nosso nome, 
                        para executar ações relacionadas a ele ou para nos ajudar a analisar como nosso Serviço é usado.
                        <br><br>
                        Essas empresas ou indivíduos terceirizados têm acesso aos seus dados apenas para realizar essas tarefas em nosso nome 
                        e são obrigados a não divulgá-los ou usá-los para qualquer outra finalidade.
                    </p>
                </b-col>
            </b-row>

            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                    Links para outros sites
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                        Nosso serviço pode conter links para outros sites que não são operados por nós. Se você clicar em um link de terceiros, será direcionado para o site. 
                        Aconselhamos vivamente que verifique a Política de Privacidade de cada site que visitar.
                        <br><br>
                        Não temos controle e não assumimos responsabilidade pelo conteúdo, políticas de privacidade ou práticas de quaisquer sites ou serviços de terceiros.
                   </p>
                </b-col>
            </b-row>

          
            
            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                    Mudanças na Política de Privacidade 
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                   Os termos de nossa Política de Privacidade poderá ser atualizado. Iremos notificá-lo de quaisquer alterações, 
                   publicando a versão atualizada da Política de Privacidade nesta página.
                   <br><br>
                   Iremos informá-lo(la) por e-mail e /ou por aviso destacado em nosso Serviço antes que a alteração entre em vigor, 
                   bem como atualizaremos a data no topo da Política de Privacidade.
                    <br><br>
                    As alterações em nossa Política de Privacidade entram em vigor quando publicadas nesta página. 
                    Aconselhamos você a revisá-la periodicamente. 
                    </p>
                </b-col>
            </b-row>

            <b-row style="padding-top:20px">
                <b-col class="paternTitle">
                    Entre em contato conosco: 
                </b-col>
            </b-row>

            <b-row style="padding-top:10px">
                <b-col>
                    <p class="patternText">
                       Caso tenha alguma questão sobre nossa Política de Privacidade, por favor entre em contato conosco:
                       <br><br>
                       <ul>
                            <li>pelo email: desenvolvedor@igarape.org.br</li>
                            <li>visitando nosso site: https://igarape.org.br/</li>
                        </ul>
                      
                    </p>

                    <br><br>
                </b-col>
            </b-row>     

            <template v-if="user.loggedIn">
                <b-row class="agreePolicyPrivacy">
                    <b-col style="display: grid; align-items: center;">
                        <b-form-checkbox v-model="privacyPolicyRead" :disabled="privacyPolicyReadSaved">
                            <span class="patternText">{{$t('policyPrivacyAgree')}}</span>
                        </b-form-checkbox>
                    </b-col>
                    <b-col>
                         <b-button v-if="!privacyPolicyReadSaved"  @click="savePolicyPrivacyAgree()" :disabled="enableButtonSavePrivacyPolicyRead">
                            {{$t('btn_save')}}
                        </b-button>
                        <b-icon v-else variant="success" icon="check2-all" font-scale="2.5"></b-icon> 
                    </b-col>
                </b-row>
            </template>
        </b-container>
    </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from '@/firebaseInit.js';
import functionsSharedMixins from '@/shared/functionsSharedMixin';
import i18n from '@/i18n.js'


export default {
    mixins: [functionsSharedMixins],
    data() {
        return {
            privacyPolicyRead: false,
            privacyPolicyReadSaved: false,
            enableButtonSavePrivacyPolicyRead :true,
            refUsers: firebase.firestore().collection('users'),
            refPlattformConfig: firebase.firestore().collection('config'),

            versionDatePrivacyPolicyPlatform:'',
            versionDatePrivacyPolicyUser:''

        };
    },

    computed: {
        ...mapGetters({
            user: "user"
        }),

    },

    watch:{
        privacyPolicyRead: function () {
            this.enableButtonSavePrivacyPolicyRead =  !this.enableButtonSavePrivacyPolicyRead
        },

    },

    methods: {
        savePolicyPrivacyAgree: function(){
            this.refUsers.doc(this.user.data.id).set({datePrivacyPolicy:firebase.firestore.Timestamp.fromDate(new Date())},{ merge: true }).then(data =>{
                this.privacyPolicyReadSaved = true
                this.$store.commit('setPrivacyPolicyOk', true)
                this.$store.commit('setShowSavedPrivacyPolicy', true)
                this.$router.push("/listActs")
            })
        },
    },

    mounted(){
        this.$store.commit('setPrivacyPolicyPage', true)
        
        if(this.$store.state.showSavedPrivacyPolicy){
            this.privacyPolicyRead = true;
            this.privacyPolicyReadSaved = true;
        } 
       
    },

  

}
</script>

<style>

.custom-control-label::before {
    top: 0.15rem !important
}

.agreePolicyPrivacy{
    padding-top:10px; 
    padding-bottom:10px; 
    border:1px solid #ccc; 
    justify-content: end; 
    display: grid !important;
    grid-template-columns: 1fr auto;
}
</style>